import { z } from "zod";
import { components } from "@opstel/gen/api/v2";

export type MessageType = "None" | "Warning" | "Info";
const messageTypeValues: MessageType[] = ["None", "Warning", "Info"];

export interface BannerMessageResponse {
  bannerMessage: string;
  messageType: MessageType;
}

export const bannerMessageSchema = z.object({
  bannerMessage: z.string(),
  messageType: z.enum(messageTypeValues),
}) satisfies z.ZodType<BannerMessageResponse, components["schemas"]["BannerMessageResponse"]>;
